"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMobileData = void 0;
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var apps_shared_1 = require("@l2p/apps-shared");
var useMobileData = function (filteredData) {
    return (0, react_1.useMemo)(function () {
        return filteredData.map(function (item, idx) {
            var amount = item.amount, winAmount = item.winAmount, result = item.result, placedAt = item.placedAt, currency = item.currency;
            return {
                amount: "".concat(amount, " ").concat((0, apps_shared_1.getCurrencySymbol)(currency)),
                winAmount: "".concat(winAmount, " ").concat((0, apps_shared_1.getCurrencySymbol)(currency)),
                result: result,
                placedAt: (0, date_fns_1.format)(new Date(placedAt), 'HH:mm, dd-LL-yy'),
                idx: idx,
            };
        });
    }, [filteredData]);
};
exports.useMobileData = useMobileData;
